module.exports = __webpack_public_path__ + "img/mtc-expert-logo.58c912c7.png";